import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEqual } from "lodash";

import { AddClientToWorkflows } from "data/hub/clients/actions";
import { SetClientWorkflowNextWorkflows } from "data/hub/clientWorkflows/actions";
import { useNotify } from "data/messages/hooks";

import {
  useClientCardNextWorkflowsQuery,
  useSubscribeToClientCardNextWorkflows,
} from ".";

export function useClientCardNextWorkflows(clientId, initialCwfs) {
  const dispatch = useDispatch();
  const [cwfs, setCwfs] = useState(initialCwfs);
  const notifyWfsToUpdate = useNotify("WORKFLOWS");

  const { reloadData, loading } = useClientCardNextWorkflowsQuery(
    clientId,
    useCallback(
      (clientWorkflows) => {
        const cwfIds = clientWorkflows.map((wf) => {
          return wf.id;
        });
        dispatch(SetClientWorkflowNextWorkflows(clientWorkflows));
        dispatch(AddClientToWorkflows(clientId, cwfIds));

        const newWorkflows = clientWorkflows.filter((workflow) => {
          return !cwfs.includes(workflow.id);
        });
        notifyWfsToUpdate(
          newWorkflows.map(({ workflowId }) => {
            return workflowId;
          })
        );

        if (!isEqual(cwfs, cwfIds)) setCwfs(cwfIds);
      },
      [dispatch, clientId, cwfs, notifyWfsToUpdate]
    )
  );

  useSubscribeToClientCardNextWorkflows(
    useCallback(() => {
      reloadData();
    }, [reloadData])
  );

  const { clientWorkflows } = useSelector(({ hubly }) => {
    return hubly.data.hub;
  });

  return {
    clientWorkflows: clientWorkflows,
    loading: loading && !clientWorkflows,
  };
}

export default useClientCardNextWorkflows;
